import {
  MAX_DISCORD_CONTEXT_MAX_MESSAGES,
  MIN_DISCORD_CONTEXT_MAX_MESSAGES,
  isDiscordContextMaxMessages,
} from "../../shared/discord-context-policy";
import type { AdminContextPolicySnapshot } from "./types";

export interface AdminContextPolicyDraft {
  contextMaxMessages: string;
}

interface ParsedAdminContextPolicyDraft {
  value?: {
    context_max_messages: number;
    half_window_messages: number;
  };
  error?: string;
}

export function adminContextPolicyDraftFromSnapshot(snapshot: AdminContextPolicySnapshot): AdminContextPolicyDraft {
  return { contextMaxMessages: String(snapshot.context_max_messages) };
}

export function parseAdminContextPolicyDraft(draft: AdminContextPolicyDraft): ParsedAdminContextPolicyDraft {
  const raw = draft.contextMaxMessages.trim();
  const parsed = raw === "" ? Number.NaN : Number(raw);
  if (!isDiscordContextMaxMessages(parsed)) {
    return { error: `消息条数必须是 ${MIN_DISCORD_CONTEXT_MAX_MESSAGES} 到 ${MAX_DISCORD_CONTEXT_MAX_MESSAGES} 的整数。` };
  }
  return {
    value: {
      context_max_messages: parsed,
      half_window_messages: Math.floor(parsed / 2),
    },
  };
}

export function isAdminContextPolicyDraftDirty(snapshot: AdminContextPolicySnapshot, draft: AdminContextPolicyDraft): boolean {
  const parsed = parseAdminContextPolicyDraft(draft);
  return parsed.value?.context_max_messages !== snapshot.context_max_messages;
}
